export default {
  tagline: 'Game keys, fairly delivered. Experience a new standard in digital distribution.',
  shop: 'SHOP',
  legal: 'LEGAL',
  help: 'HELP',
  marketplace: 'Marketplace',
  catalog: 'Catalog',
  articles: 'Articles',
  terms: 'Terms',
  privacy: 'Privacy',
  cookies: 'Cookies',
  support: 'Support',
  faq: 'FAQ',
  language: 'Language',
  legalLine:
    'PlayStock Placeholder Ltd. Placeholder address, Riga, Latvia · VAT: LV40012345678 · Reg. No.: 40012345678',
  copyright: '© 2026 PlayStock. Game keys, fairly delivered.',
};
